// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import EditorLevel from '../models/editor-level';

export default class NavigationToolbarItem extends React.Component {
  static propTypes = {
    level: PropTypes.instanceOf(EditorLevel).isRequired,
    last: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  render() {
    const { styles } = NavigationToolbarItem;

    return (
      <a
        className={css(styles.button, this.props.last && styles.last)}
        onClick={this.handleClick}
        href="#"
        title={this.props.level.displayName}
      >
        {this.props.level.displayName}
      </a>
    );
  }

  handleClick = (event) => {
    event.preventDefault();

    this.props.onClick(this.props.level);
  };
}

const styles = cssInJS({
  button: {
    display: 'inline-block',
    color: THEME.linkColor,
    paddingLeft: 6,
    paddingTop: 12,
    paddingRight: 0,
    textDecoration: 'none',
    fontSize: 13,
    lineHeight: '13px',
    transition: 'color 500ms ease',
    flex: '0 1 auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 80,
  },

  last: {
    color: '#000',
    cursor: 'default',

    ':hover': {
      color: '#000',
    },
  },
});

NavigationToolbarItem.styles = styles;
